import { cn } from "@/lib/utils";

interface OptionChipGroupProps {
  label: string;
  options: string[];
  selected: string;
  onSelect: (val: string) => void;
}

export const OptionChipGroup = ({ label, options, selected, onSelect }: OptionChipGroupProps) => {
  return (
    <div className="space-y-2.5">
      <h3 className="text-sm font-medium text-muted-foreground">{label}</h3>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const isSelected = selected === opt;
          return (
            <button
              key={opt}
              onClick={() => onSelect(opt)}
              className={cn(
                "px-4 py-2 rounded-xl text-sm transition-all border font-medium",
                isSelected 
                  ? "border-primary bg-primary text-primary-foreground shadow-sm" 
                  : "border-border bg-background hover:border-primary/40 text-foreground"
              )}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
};
